import { cn } from "@newxsystems/shared";
import { AbyssAction } from "../AbyssAction/AbyssAction";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import { AbyssRichText } from "../AbyssRichText/AbyssRichText";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";

const widths = { small: "w-2/3", medium: "w-5/6", large: "w-full" } as const;

export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => (
  <div className="grid grid-cols-1 items-center gap-7 md:grid-cols-2 md:gap-12">
    {eyebrow ? (
      <p className="abyss-kicker order-1 text-frost before:bg-frost/55 md:col-start-1">{eyebrow}</p>
    ) : null}
    {image ? (
      <AbyssMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className={cn(
          "order-2 w-full justify-self-end md:col-start-2 md:row-span-4 md:row-start-1",
          widths[imageWidth || "medium"],
        )}
        media={image.image}
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    ) : null}
    {heading ? (
      <h2 className="abyss-type-section order-3 font-abyss-display font-medium md:col-start-1">
        {heading}
      </h2>
    ) : null}
    {description ? (
      <AbyssRichText
        className="order-4 max-w-[65ch] text-frost md:col-start-1"
        content={description}
      />
    ) : null}
    {buttons?.length ? (
      <div
        className={cn(
          "order-5 flex flex-wrap gap-3",
          image
            ? "md:col-start-1"
            : "md:col-start-2 md:row-span-3 md:row-start-1 md:justify-self-end",
        )}
      >
        {buttons.map((button, index) => (
          <AbyssAction action={button} key={`${button.href}-${index}`} />
        ))}
      </div>
    ) : null}
  </div>
);

CallToActionSplit.displayName = "Content::CallToActionSplit";
